// extracted by mini-css-extract-plugin
export default {"root":"Orders_root__7mWhX"};